<template>
	<div class="siteadmin">
		<loading
			:active.sync="fullPageWait"
			:can-cancel="false"
			:is-full-page="true"
		/>
		<b-modal
			id="modal-1"
			title="EDIT"
			v-model="editYC"
			no-close-on-backdrop
			@ok="saveYC"
			ok-variant="info"
		>
            <b-form-group label="master" label-for="masterYC">
				<b-form-input
					id="masterYC"
					v-model="masterYC"
					required
				></b-form-input>
			</b-form-group>
			<b-form-group label="slave" label-for="slaveYC">
				<b-form-input
					id="slaveYC"
					v-model="slaveYC"
					required
				></b-form-input>
			</b-form-group>
			<b-form-group label="note" label-for="noteYC">
				<b-form-input
					id="noteYC"
					v-model="noteYC"
					required
				></b-form-input>
			</b-form-group>
		</b-modal>
		<b-modal
			id="modal-1"
			:title="`Test ${mailTest.title}`"
			v-model="mailTestDlg"
			no-close-on-backdrop
			@ok="testPromo2"
			ok-variant="info"
		>
			<b-form-group label="email" label-for="testEmail">
				<b-form-input
					id="testEmail"
					v-model="testEmail"
					required
				></b-form-input>
			</b-form-group>
		</b-modal>
		<b-modal
			no-close-on-backdrop
			title="Filtered clients"
			class="modal-success"
			v-model="clientsDlg"
			ok-variant="success"
			:ok-only="true"
			ok-title="Close"
			size="lg"
		>
			<b-container fluid>
				<template v-if="clients === false">
					<SemipolarSpinner
						:animation-duration="2000"
						:size="65"
						:color="'#ff1d5e'"
					/>
				</template>
				<template v-else>
					<b-row v-for="c in clients" :key="c.client_name">
						<b-col>{{ c.client_name }}</b-col>
					</b-row>
				</template>
			</b-container>
		</b-modal>
		<b-modal
			no-close-on-backdrop
			title="Edit Promo"
			class="modal-danger"
			v-model="editPromo"
			@ok="savePromo"
			ok-variant="danger"
		>
			<b-form v-if="editPromo">
				<b-container>
					<b-row>
						<b-col>
							<b-form-group
								label="Promo Filter"
								label-for="promoFilter"
							>
								<b-form-select
									id="promoFilter"
									v-model="promo.promofilterid"
									:options="promoFilterOptions"
									required
								></b-form-select>
							</b-form-group>
							<b-form-group
								label="Promo Image"
								label-for="promoImage"
							>
								<b-form-select
									id="promoImage"
									v-model="promo.promoimage"
									:options="promoImages"
									required
								></b-form-select>
							</b-form-group>
							<b-form-group
								label="Promo Link"
								label-for="promoLink"
							>
								<b-form-input
									id="promoLink"
									v-model="promo.link"
									required
								></b-form-input>
							</b-form-group>
							<b-form-group
								label="Promo Title"
								label-for="promoTitle"
							>
								<b-form-input
									id="promoTitle"
									v-model="promo.title"
									required
								></b-form-input>
							</b-form-group>
							<b-form-group
								label="Promo Description"
								label-for="promoDescription"
							>
								<b-form-textarea
									id="promoDescription"
									v-model="promo.description"
									required
									rows="3"
								></b-form-textarea>
							</b-form-group>
							<b-form-group
								label="Promo From Date"
								label-for="promoFromDate"
							>
								<b-form-datepicker
									id="promoFromDate"
									v-model="promo.fromdate"
									required
								></b-form-datepicker>
							</b-form-group>
							<b-form-group
								label="Promo To Date"
								label-for="promoToDate"
							>
								<b-form-datepicker
									id="promoToDate"
									v-model="promo.todate"
									required
								></b-form-datepicker>
							</b-form-group>
							<b-form-group
								label="Template"
								label-for="templateId"
							>
								<b-form-select
									id="templateId"
									v-model="promo.template_id"
									:options="templates"
									required
								></b-form-select>
							</b-form-group>
							<b-form-group
								label="Promo Active"
								label-for="promoActive"
							>
								<b-form-checkbox
									id="promoActive"
									v-model="promo.active"
									required
								></b-form-checkbox>
							</b-form-group>
						</b-col>
					</b-row>
				</b-container>
			</b-form>
		</b-modal>
		<template v-if="waiting">
			<SemipolarSpinner
				:animation-duration="2000"
				:size="65"
				:color="'#ff1d5e'"
			/>
		</template>
		<template v-else>
			<b-tabs content-class="mt-3" @input="tabChanged">
				<b-tab title="Banner" active>
					<b-card title="Upload Banner Image" v-if="!$store.getters.ro">
						<img src="/images/banner.jpg" width="200" />
						<b-form @submit="onSubmit('banner')" @reset="onReset">
							<b-row>
								<b-col>
									<b-form-file
										v-model="file"
										:state="Boolean(file)"
										placeholder="Choose a file or drop it here... 1920x1080 jpg image"
										drop-placeholder="Drop file here... 1920x1080 jpg image"
									></b-form-file>
									<b-button
										@click="file = null"
										v-if="Boolean(file)"
										>Reset</b-button
									>
								</b-col>
							</b-row>
							<b-button type="submit" variant="primary"
								>Submit</b-button
							>
						</b-form>
					</b-card>
				</b-tab>
				<b-tab title="Promo Filters">
					<b-container fluid>
                        <b-row>
                            <b-col>
                                <b-form inline>
                                    <b-form-group
                                        label="Spares filter:"
                                        label-for="spareFilter"
                                        description="Filter on Spares code"
                                        class="sfLabel"
                                    >
                                        <b-form-input
                                            id="spareFilter"
                                            v-model="spareFilter"
                                            type="text"
                                            placeholder="Enter spare codes separated by comma and press ENTER"
                                            @change="spChanged"
                                        ></b-form-input>
                                    </b-form-group>
                                </b-form>
                            </b-col>
                        </b-row>
						<b-row>
							<b-col cols="9">
								<div class="totals" v-if="!!totals">
									<b class="clients" @click="showClients"
										>Clients</b
									>:{{ totals.k1 }} <b>Machines</b>:{{
										totals.k2
									}}
									<b>Spare Codes</b>:{{ totals.k3 }}
									<b>Areas</b>:{{ totals.k4 }}
									<b>Countries</b>:{{ totals.k5 }}
								</div>
								<AgGridVue
									style="
										width: calc(100% - 20px);
										height: calc(100vh - 180px);
									"
									class="ag-theme-alpine"
									rowModelType="serverSide"
									:debug="true"
									:pagination="true"
									:paginationPageSize="20"
									:cacheBlockSize="20"
									:serverSideDatasource="serverSideDatasource"
									:serverSideStoreType="'partial'"
									:columnDefs="columnDefsPF"
									:defaultColDef="defaultColDef"
									:suppressColumnVirtualisation="false"
									@first-data-rendered="onFirstDataRenderedPF"
									@grid-ready="onGridReadyPF"
									@store-updated="StoreUpdated"
									@grid-size-changed="gridSizeChangedPF"
								>
								</AgGridVue>
							</b-col>
							<b-col cols="3">
								<div class="form">
									<b-form>
										<b-form-group
											label="Descrizione:"
											label-for="descrFilter"
											description="Descrizione/Nome della promozione"
										>
											<b-form-input
												id="descrFilter"
												v-model="form.text"
												type="text"
												placeholder="Enter text"
												required
											></b-form-input>
										</b-form-group>
										<b-button
                                            v-if="!$store.getters.ro"
											type="button"
											variant="primary"
											@click="insDescrClick"
											>ADD</b-button
										>
										<b-button
											type="button"
											variant="primary"
											@click="resetClick"
											>Reset</b-button
										>
									</b-form>

									<table
										class="listpromos"
										v-if="promoFilters.length > 0"
										width="100%"
									>
										<tr>
											<th align="left">Promo</th>
											<th width="160px">Action</th>
										</tr>
										<tr
											v-for="promo of promoFilters"
											:key="promo.promofilter.name"
										>
											<td>
												{{ promo.promofilter.name }}
											</td>
											<td>
												<b-button
                                                    v-if="!$store.getters.ro"
													type="button"
													variant="danger"
													@click="
														delPromoFilter(
															promo.promofilter
																.name
														)
													"
													>Delete</b-button
												>
												<b-button
													type="button"
													variant="primary"
													@click="
														getPromoFilter(
															promo.promofilter
																.name
														)
													"
													>Recall</b-button
												>
											</td>
										</tr>
									</table>
									<div v-else class="listpromos">
										No promo filters defined
									</div>
								</div>
							</b-col>
						</b-row>
					</b-container>
				</b-tab>
				<b-tab title="Promo Setup">
					<b-button class="add" title="add" @click="newRec" v-if="!$store.getters.ro">
						<v-icon name="plus" scale="1" />
					</b-button>
					<b-container fluid>
						<b-row>
							<b-col>
								<AgGridVue
									style="
										width: calc(100% - 20px);
										height: calc(100vh - 180px);
									"
									class="ag-theme-alpine"
									:columnDefs="columnDefsP"
									:rowData="promos"
									:defaultColDef="defaultColDef"
									:suppressColumnVirtualisation="false"
									@first-data-rendered="onFirstDataRenderedP"
									@grid-ready="onGridReadyP"
									@grid-size-changed="gridSizeChangedP"
								>
								</AgGridVue>
							</b-col>
						</b-row>
					</b-container>
				</b-tab>
				<b-tab title="Promo Images">
					<b-card title="Upload Promo Image">
						<b-container>
							<b-row>
								<b-col v-for="i of promoImages" :key="i.id">
									<img
										:src="`/images/promo/${i}`"
										width="100"
									/><br />
									<b-button
                                        v-if="!$store.getters.ro"
										type="button"
										variant="danger"
										@click="delPromoImage(i)"
										>Delete</b-button
									>
								</b-col>
							</b-row>
						</b-container>
						<b-form @submit="onSubmit('promo')" @reset="onReset" v-if="!$store.getters.ro">
							<b-row>
								<b-col>
									<b-form-file
										v-model="file"
										:state="Boolean(file)"
										placeholder="Choose a file or drop it here... 300x300 png image"
										drop-placeholder="Drop file here... 300x300 png image"
									></b-form-file>
									<b-button
										@click="file = null"
										v-if="Boolean(file)"
										>Reset</b-button
									>
								</b-col>
							</b-row>
							<b-button type="submit" variant="primary"
								>Submit</b-button
							>
						</b-form>
					</b-card>
				</b-tab>
				<b-tab title="YCUSTJERAR">
                    <b-row>
                        <b-col>
                            <div style="overflow-x:auto;width:100%;" class=table>
                                <vue-good-table
                                    :columns="columns"
                                    :rows="ycustjerar"
                                    styleClass="vgt-table condensed striped bordered"
                                    :_fixed-header="true"
                                    row-style-class=""
                                    :pagination-options="pagopts"
                                    :sort-options="{ enabled: true }"
                                    :search-options="{
                                        enabled: true,
                                        trigger: 'key-up', // enter
                                        skipDiacritics: true,
                                        //searchFn: mySearchFn,
                                        placeholder: 'Search',
                                        //externalQuery: searchQuery
                                    }"
                                    >
                                    <div slot="table-actions">
                                        <b-button class="add" title="add" @click="newYC" v-if="!$store.getters.ro">
                                            <v-icon name="plus" scale="1" />
                                        </b-button>
                                    </div>
                                    <template slot="table-column" slot-scope="props">{{props.column.label}}</template>
                                    <template slot="table-row" slot-scope="props">
                                        <span v-if="props.column.field == 'actions'">
                                        <b-button title="delete" @click="delitem(props.formattedRow['master'] + '_' + props.formattedRow['slave'])" v-if="!$store.getters.ro">
                                            <v-icon name="trash" scale="1" />
                                        </b-button>
                                        </span>
                                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                                    </template>
                                </vue-good-table>
                            </div>
                        </b-col>
                    </b-row>
                </b-tab>
			</b-tabs>
		</template>
		<b-alert
			:show="dismissCountDown"
			dismissible
			variant="info"
			@dismissed="dismissCountDown = 0"
			@dismiss-count-down="countDownChanged"
		>
			Image uploaded!
		</b-alert>
	</div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { API } from "@/api.js";
import { SemipolarSpinner } from "epic-spinners";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);


export default {
	name: "SiteAdmin",
	components: {
		AgGridVue,
		SemipolarSpinner,
		Loading,
        VueGoodTable
	},
	data() {
		console.log("DUMMY", this.promoOpsRenderer);
		return {
            editYC: false,
            ycustjerar: [],
            masterYC: "",
            slaveYC: "",
            noteYC: "",
            columns: [],
			fullPageWait: false,
			testEmail: "", // destinatario
			mailTestDlg: false,
			mailTest: {}, // promo da testare per email
			templates: [],
			waiting: true,
			currTab: 0,
			dismissCountDown: 0,
			dismissSecs: 5,
			file: null,
            spareFilter: "",
			columnDefsPF: [
				{
					headerName: "Client",
					field: "client_name",
					filter: "agTextColumnFilter",
					filterParams: { buttons: ["reset", "apply"] },
				},
				{
					headerName: "Machine",
					field: "ITMREF_0",
					filter: "agTextColumnFilter",
					filterParams: { buttons: ["reset", "apply"] },
				},
				{
					headerName: "Spare Code",
					field: "spare_code",
					filter: "agTextColumnFilter",
					filterParams: { buttons: ["reset", "apply"] },
				},
				{
					headerName: "Spare Descr.",
					cellClass: "ag-left-aligned-cell",
					maxWidth: 450,
					type: "leftAligned",
					field: "text",
					filter: "agTextColumnFilter",
					filterParams: { buttons: ["reset", "apply"] },
				},
				{
					headerName: "Date.",
					field: "date",
					filter: "agDateColumnFilter",
					valueFormatter: this.dateFormatter,
					filterParams: { buttons: ["reset", "apply"] },
				},
				{
					headerName: "Area",
					field: "area",
					filter: "agTextColumnFilter",
					filterParams: { buttons: ["reset", "apply"] },
				},
				{
					headerName: "Country",
					field: "country",
					filter: "agTextColumnFilter",
					filterParams: { buttons: ["reset", "apply"] },
				},
			],
			columnDefsP: [
				{
					headerName: "Filter",
					field: "promofilterid",
					cellRenderer: (params) => {
						return this.promoFilters.find(
							(pf) => pf.id == params.value
						).promofilter.name;
					},
				},
				{
					headerName: "Image",
					field: "promoimage",
					cellRenderer: (params) => {
						return `<img height="100%" src="/images/promo/${params.value}">`;
					},
				},
				{
					headerName: "Link",
					field: "link",
					filter: "agTextColumnFilter",
				},
				{
					headerName: "Title",
					field: "title",
					filter: "agTextColumnFilter",
				},
				{
					headerName: "Description",
					field: "description",
					filter: "agTextColumnFilter",
					width: 300,
					suppressSizeToFit: true,
					maxWidth: 300,
				},
				{
					headerName: "From Date",
					field: "fromdate",
					filter: "agDateColumnFilter",
					valueFormatter: this.dateFormatter,
				},
				{
					headerName: "To Date",
					field: "todate",
					filter: "agDateColumnFilter",
					valueFormatter: this.dateFormatter,
				},
				{
					headerName: "Template",
					field: "template_id",
					cellRenderer: (params) => {
						return this.templates.find(
							(t) => t.value == (params.value || 0)
						).text;
					},
				},
				{ headerName: "Active", field: "active" },
				{
					headerName: "Row",
					field: "id",
					cellRenderer: (params) => {
						return `<button class=cellBtn onClick="siteadmin.edit(${params.value})"><span>Edit</span></button>
								<button class=cellBtn onClick="siteadmin.del(${params.value})"><span>Del</span></button>`;
					},
				},
				{
					headerName: "Campagna",
					field: "id",
					cellRenderer: (params) => {
						let ret = "";
						console.log("??", params.data);
                        let canSave = params.data.template_id && !params.data.active
                        let canTest = canSave && params.data.campaign_id && params.data.campaign_id!="0"
                        let canSend = canTest && params.data.template_id && !params.data.active && params.data.recipients && params.data.recipients!=""
						if (canSave)
							ret += `<button class=cellBtn onClick="siteadmin.create(${params.value})"><span>Create/Upd</span></button>`;
						else
							ret += `<button disabled class=cellBtn onClick="siteadmin.create(${params.value})"><span>Create/Upd</span></button>`;
						if (canTest)
							ret += `<button class=cellBtn onClick="siteadmin.testPromo1(${params.value})"><span>Test</span></button>`;
						else
							ret += `<button disabled class=cellBtn onClick="siteadmin.testPromo1(${params.value})"><span>Test</span></button>`;
						if (canSend)
							ret += `<button class=cellBtn onClick="siteadmin.sendPromo(${
								params.value
							},'${
								params.data.title
							}','${params.data.fromdate.toISOString()}')"><span>Send</span></button>`;
						else
							ret += `<button disabled class=cellBtn onClick="siteadmin.sendPromo(${params.value},'${params.data.title}')"><span>Send</span></button>`;
						return ret;
					},
				},
			],
			defaultColDef: {
				sortable: true,
				filter: true,
				resizable: true, 
			},
			gridApiPF: null,
			columnApiPF: null,
			gridApiP: null,
			columnApiP: null,
			form: {
				text: "",
			},
			promoFilters: [],
			promos: [],
			editPromo: false,
			promo: null,
			promoImages: [],
			totals: null,
			clients: false, // elenco dei clienti filtrati
			clientsDlg: false,
			serverSideDatasource: {
				getRows: async (params) => {
					this.clients = false;
                    params.spareFilter = this.spareFilter
					console.log("getRows", params);
					var response = await API.getSparesServer(params);
					// console.log("RESPONSE", response);
					response.rows = response.rows.map((d) => ({
						client_name: d.client_name,
						ITMREF_0: d.ITMREF_0,
						spare_code: d.spare_code,
						text: d.text,
						date: new Date(d.date),
						area: d.area,
						country: d.country,
					}));
					this.totals = {
						k1: "?",
						k2: "?",
						k3: "?",
						k4: "?",
						k5: "?",
					};
					setTimeout(async () => {
                        params.spareFilter = this.spareFilter
						params.totals = true;
						var response = await API.getSparesServer(params);
						this.totals = response.rows[0];
						console.log("TOTALS", this.totals);
						params.totals = false;
						params.clients = true;
                        params.spareFilter = this.spareFilter
						response = await API.getSparesServer(params);
						this.clients = response.rows.sort((a, b) => {
							return a.client_name.localeCompare(b.client_name);
						});
						console.log("CLIENTS", this.clients);
					}, 1);
					if (response.success) {
						params.successCallback(response.rows, response.lastRow);
					} else {
						params.fail();
					}
				},
			},
		};
	},
	computed: {
		promoFilterOptions() {
			return this.promoFilters.map((pf) => {
				return {
					text: pf.promofilter.name,
					value: pf.id,
				};
			});
		},
        pagopts(){
            let perpage = localStorage.getItem("TabPerPage") || 10
            return {
                        enabled: true,
                        mode: 'records',
                        perPage: perpage*1,
                        position: 'top',
                        perPageDropdown: [5, 10, 20, 50, 100, 200, 500, 1000],
                        dropdownAllowAll: false,
                        setCurrentPage: 1,
                        nextLabel: 'next',
                        prevLabel: 'prev',
                        rowsPerPageLabel: 'Righe per pagina',
                        ofLabel: 'di',
                        pageLabel: 'pagina', // for 'pages' mode
                        allLabel: 'All',
                    }
        },
	},
	async mounted() {
		window.siteadmin = this; // serve ai pulsanti nella agGrid (che tristezza...)
		try {
			this.promoFilters = await API.getPromoFilters();
			await this.getPromos();
			this.promoImages = await API.getPromoImages();
			// console.log("promos", this.promos);
			this.templates = (await API.getTemplates()).map((t) => ({
				value: t.id,
				text: t.name,
				thumbnail: t.thumbnail,
			}));
			this.templates.unshift({ value: 0, text: "N.D.", img: null });
			console.log("templates", this.templates);

            this.refresh()
		} catch (error) {
			console.error("SiteAdmin Mount", error);
		}
		this.waiting = false;
	},
	methods: {
        async refresh() {
            let response = await API.getTabella("ycustjerar")
            this.columns = [{ label: "Master", field: "master" },
                            { label: "Slave", field: "slave" },
                            { label: "Master RS", field: "nm" },
                            { label: "Slave RS", field: "ns" },
                            { label: "Note", field: "note" }]
            this.ycustjerar = response.map(r => ({master: r.BPCNUMMAST_0,slave: r.BPCNUMSLAVE_0,note: r.RAGSOCABB_0,nm: r.nm,ns: r.ns}));
            this.columns.push({ label: "actions", field: "actions" });
        },
        spChanged(){
            console.log("Changed",this.spareFilter)
            this.gridApiPF.onFilterChanged();
        },
		async getPromos() {
			let promos = await API.getPromos();
			this.promos = promos.map((d) => ({
				id: d.id,
				promofilterid: d.promofilterid,
				promoimage: d.promoimage,
				link: d.link,
				title: d.title,
				description: d.description,
				recipients: d.recipients,
				template_id: d.template_id || 0,
				campaign_id: d.campaign_id || 0,
				fromdate: new Date(d.fromdate),
				todate: new Date(d.todate),
				active: !!d.active,
			}));
		},
		showClients() {
			this.clientsDlg = true;
		},
		newRec() {
			console.log("newRec");
			this.promo = { id: 0 };
			this.editPromo = true;
		},
		newYC() {
			console.log("newRec");
			this.editYC = true;
		},
		async savePromo() {
			console.log("savePromo", this.promo);
			let id = await API.setPromo(this.promo);
			if (this.promo.id == 0) {
				this.promo.id = id;
				this.promos.push(this.promo);
			}
			await this.getPromos();
			await API.updatePromoMachines();
			this.gridApiP.refreshCells({});
		},
		async saveYC() {
			console.log("saveYC", this.promo);
            let dato = {master: this.masterYC, slave:this.slaveYC, note:this.noteYC}
            API.setTabella("ycustjerar", dato, false, null);
            this.ycustjerar.push({master: this.masterYC,slave: this.slaveYC,note: this.noteYC})
            this.masterYC = ""
            this.slaveYC = ""
            this.noteYC = ""
        },
        async delitem(id) {
            await API.delTabella("ycustjerar",'id',id)
            this.ycustjerar = this.ycustjerar.filter(r => r.master!=id.split("_")[0] || r.slave!=id.split("_")[1])
        },
		edit(p) {
			console.log("edit", p);
			this.promo = this.promos.find((d) => d.id == p);
			this.editPromo = true;
		},
		async del(pid) {
			let c = await this.$bvModal.msgBoxConfirm(
				"Do you really want to delete this promo ??"
			);
			if (c === true) {
                console.log("P",pid)
				await API.delPromo(pid);
                await this.getPromos();
				await API.updatePromoMachines();
                this.gridApiP.refreshCells({});
			}
		},
		async create(p) {
			console.log("CREATE", p);
			let c = await this.$bvModal.msgBoxConfirm(
				"Do you really want to create/update campaign for this promo ??"
			);
			if (c === true) {
				this.fullPageWait = true;
				let ret = await API.updPromoCampaign(p);
                console.log("RET",ret)
                if(ret!="OK") {
                    let text = JSON.parse(ret.response.text).detail
                    alert(text)
                }
                await API.updatePromoMachines();
				await this.getPromos()
				this.fullPageWait = false;
                setTimeout(() => { this.gridApiP.redrawRows({}); }, 100)
			}
		},
		testPromo1(p) {
			console.log("MAILTEST", p);
			this.mailTest = p;
			this.mailTestDlg = true;
		},
		async testPromo2() {
			let email = this.testEmail;
			console.log({ email });
			this.fullPageWait = true;
            API.updatePromoMachines();
			await API.promoCampaignTest(this.mailTest, email);
			this.fullPageWait = false;
		},
		async sendPromo(id, pname, fromdate) {
			// se la data è nel futuro propongo una schedulazione
			let d1 = new Date(fromdate).getTime();
			let d2 = new Date().getTime();
			let value;
			if (d1 > d2)
				value = await this.$bvModal.msgBoxConfirm(
					"Do you really want to schedule this campaign ?"
				);
			else
				value = await this.$bvModal.msgBoxConfirm(
					"Do you really want to send this campaign ?"
				);
			if (value) {
				let ret;
				if (d1 > d2) {
					fromdate = fromdate.split("T")[0]; // 2022-10-11T12:13:00.123Z
					ret = await API.promoCampaignSend(id, fromdate);
				} else {
					ret = await API.promoCampaignSend(id);
				}

				console.log("SENT:", ret);
				if (ret && ret.response && ret.response.text) {
					let jtext = JSON.parse(ret.response.text);
					await this.$bvModal.msgBoxOk(
						jtext.title + " " + jtext.detail
					);
				} else {
					// mando l'avviso via email
					let dests = await API.getPromoDests(1);
					let text = "Destinatari:";
					text += dests.join("\n");
					let html = "<b>Destinatari:</b><br>";
					html += dests.join("<br>");
					console.log("TEXT", text);
					console.log("HTML", html);
					API.sendmail(
						"promo_mail_sent",
						`E' stata inviata la campagna ${pname}`,
						text,
						html
					);
					await this.$bvModal.msgBoxOk("Command executed");
				}
			}
		},
		dateFormatter(params) {
			console.log("???", params,typeof params.value);
            if(typeof params.value === "object")
                return params.value.toDateString();
            else
                return new Date(params.value).toDateString();
		},
		delPromoFilter(name) {
			let oldpromo = this.promoFilters.find(
				(p) => p.promofilter.name == name
			);
			if (oldpromo) API.delPromoFilter(oldpromo.id);
			this.promoFilters = this.promoFilters.filter(
				(p) => p.promofilter.name != name
			);
			API.updatePromoMachines();
		},
		getPromoFilter(name) {
			let p = this.promoFilters.find(
				(p) => p.promofilter.name == name
			).promofilter;
            this.spareFilter = p.spareFilter
			for (let field of this.columnDefsPF.map((cd) => cd.field)) {
				let filterComponent = this.gridApiPF.getFilterInstance(field);
				filterComponent.setModel(p.filterModel[field]);
				this.gridApiPF.onFilterChanged();
			}
			this.columnApiPF.applyColumnState({
				state: p.colState,
				applyOrder: true,
			});
			this.form.text = name;
		},
		resetClick() {
			for (let field of this.columnDefsPF.map((cd) => cd.field)) {
				let filterComponent = this.gridApiPF.getFilterInstance(field);
				// filterComponent.resetFilterValues ();
				// filterComponent.applyModel()
				filterComponent.setModel(null);
				this.gridApiPF.onFilterChanged();
			}
			this.columnApiPF.resetColumnState();
			this.form.text = "";
		},
		async insDescrClick() {
			if (!this.form.text || this.form.text == "") return;
			// ne elimino una con lo stesso nome
			await this.delPromoFilter({ name: this.form.text });
			let state = {};
			state.colState = this.columnApiPF.getColumnState();
			state.filterModel = {};
			for (let field of this.columnDefsPF.map((cd) => cd.field)) {
				let filterComponent = this.gridApiPF.getFilterInstance(field);
				let model = filterComponent.getModel();
				state.filterModel[field] = model;
			}
			state.name = this.form.text;
            state.spareFilter = this.spareFilter
			let { id } = API.setPromoFilter(null, state);
			this.promoFilters.push({ id, promofilter: state });
			// this.form.text = ''
			// state.groupState = this.columnApiPF.getColumnGroupState();
			// state.filterState = this.api.getFilterModel();
			// state.pivot = this.columnApiPF.isPivotMode();
			// state.globalfilter = $("#global-filter").val();
			console.log("STATE", state);
		},
		tabChanged(index) {
			this.currTab = index;
			if (index == 1) {
				// la grid
				setTimeout(() => {
					this.columnApiPF.autoSizeAllColumns();
				}, 1000);
			}
			if (index == 2) {
				// la grid
				setTimeout(() => {
					this.columnApiP.autoSizeAllColumns();
				}, 1000);
			}
		},
		// eslint-disable-next-line no-unused-vars
		gridSizeChangedPF(event) {
			// console.log("gridSizeChangedPF", event);
			// qui non va bene perché scatena un resize in loop
			// event.columnApiPF.autoSizeAllColumns()
		},
		onGridReadyPF(params) {
			// console.log("onGridReadyPF", params);
			this.gridApiPF = params.api;
			this.columnApiPF = params.columnApi;
		},
		// eslint-disable-next-line no-unused-vars
		onFirstDataRenderedPF(event) {
			// console.log("onFirstDataRenderedPF", event);
			if (this.currTab == 1) this.columnApiPF.autoSizeAllColumns();
		},
		// eslint-disable-next-line no-unused-vars
		StoreUpdated(event) {
			// console.log("StoreUpdated", event);
			if (this.currTab == 1) {
				setTimeout(() => {
					this.columnApiPF.autoSizeAllColumns();
				}, 500);
			}
		},
		// eslint-disable-next-line no-unused-vars
		gridSizeChangedP(event) {
			// console.log("gridSizeChangedP", event);
			// qui non va bene perché scatena un resize in loop
			// event.columnApiPF.autoSizeAllColumns()
		},
		onGridReadyP(params) {
			// console.log("onGridReadyP", params);
			this.gridApiP = params.api;
			this.columnApiP = params.columnApi;
		},
		// eslint-disable-next-line no-unused-vars
		onFirstDataRenderedP(event) {
			// console.log("onFirstDataRenderedP", event);
			if (this.currTab == 2) this.columnApiP.autoSizeAllColumns();
		},
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		showAlert() {
			this.dismissCountDown = this.dismissSecs;
		},
		async onSubmit(image) {
			// console.log("onSubmit", image, this.file);
			const formData = new FormData();
			formData.append(image, this.file);
			await API.uploadImage(formData);
			this.showAlert();
			this.promoImages = await API.getPromoImages();
		},
		async delPromoImage(image) {
			// console.log("delPromoImage", image);
			await API.delPromoImage(image);
			this.promoImages = await API.getPromoImages();
		},
		onReset() {
			// console.log("onReset");
		},
	},
};
</script>
<style>
.ag-left-aligned-cell {
	text-align: left;
}
div.siteadmin div.vgt-global-search__input{
    padding-right: 100px;
}
div.vgt-global-search__actions button {
    position: relative !important;
    top: -10px;
}
</style>
<style scoped>
div.sfLabel {
    position: relative;
    top: -11px;
    margin-right: 8px;
}
div.sfLabel input {
    width: 600px;
}
div.totals b.clients {
	cursor: pointer;
}
button.add {
	position: absolute;
	right: 40px;
	margin-top: 6px;
	z-index: 2;
}
table.listpromos td {
	text-align: left;
}
table.listpromos th:nth-child(1) {
	text-align: left;
}
button {
	margin: 3px;
}
/* Altrimenti con la grid ho un continuo cambiamento della larghezza */
div.tab-pane {
	width: calc(100vw - 20px);
}
.listpromos {
	margin-top: 50px;
}
div.form {
	height: calc(100vh - 180px);
	overflow: auto;
}
</style>
<style>
button.cellBtn {
	height: 30px;
	margin-top: 4px;
}
button.cellBtn span {
	position: relative;
	bottom: 8px;
}
</style>
